import { SOCIAL_SHARING_FACEBOOK, SOCIAL_SHARING_TWITTER, SOCIAL_SHARING_LINKED_IN, } from '../constants/social-sharing';
import { urijs } from '../helpers/urijs';
const WIDTH = 640;
const HEIGHT = 640;
const isIOS = () => /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
const isMobile = () => /Android/.test(navigator.userAgent) || isIOS();
/**
 * On iOS, a popup-sized window.open() is treated as an auxiliary browsing
 * context and Universal Links to native apps often do not fire. Prefer the
 * native share sheet for Facebook (in-app composer), and a plain new tab
 * otherwise so the OS can hand off to native apps.
 */
const openShareDialog = (url, { preferNativeShare, nativeShareData } = {}) => {
    if (preferNativeShare && typeof navigator.share === 'function') {
        navigator.share(nativeShareData).catch(() => { });
        return;
    }
    if (isMobile()) {
        window.open(url, '_blank');
        return;
    }
    window.open(url, 'Share', `width=${WIDTH},height=${HEIGHT},toolbar=no,menubar=no,scrollbars=no,location=no,status=no`);
};
const encodeUrlTwice = (href) => {
    const uri = new urijs(href);
    uri.pathname(encodeURI(encodeURI(uri.pathname())));
    return uri.toString();
};
const getUrl = (socialNetwork, href) => {
    switch (socialNetwork) {
        case SOCIAL_SHARING_FACEBOOK:
            return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(href)}`;
        case SOCIAL_SHARING_TWITTER:
            return `https://twitter.com/share?url=${encodeUrlTwice(href)}`;
        case SOCIAL_SHARING_LINKED_IN:
            return `https://www.linkedin.com/shareArticle?mini=true&url=${href}`;
        default:
            return;
    }
};
export default function share(type, path) {
    const url = getUrl(type, path);
    if (!url) {
        return;
    }
    openShareDialog(url, {
        preferNativeShare: type === SOCIAL_SHARING_FACEBOOK && isIOS(),
        nativeShareData: { url: path },
    });
}
//# sourceMappingURL=share.js.map